module.exports = __webpack_public_path__ + "img/search.75e42a3c.svg";